var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Overlays,{attrs:{"is-show":_setup.store.state.app.OverlayStatus}}),_c(_setup.resolveLayout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }